// extracted by mini-css-extract-plugin
export default {"sideDrawerFormBtnFixed":"commonCss_sideDrawerFormBtnFixed__CIGpD"};